import * as React from 'react'
import { styled } from '../styled-components'
import { Input } from './Forms'

interface IProps {
  label?: string
  type?: string
  className?: string
  value?: string
  onChange?: (value: string) => void
  required?: boolean
  placeholder?: string
}

export const TextControl = (props: IProps) => {
  const { value, onChange, type, required, placeholder } = props
  return (<Container className={props.className}>
    {props.label && <Label>{props.label}</Label>}
    <StyledInput {...{value, type, required, placeholder}} onChange={(e) => { onChange && onChange(e.target.value) }} />
  </Container>)
}

const Container = styled.div`
  display: flex;
  flex-direction: column;
`

const Label = styled.label`
  font-size: 17px;
  margin-bottom: 5px;
`

const StyledInput = styled(Input)`
  margin-bottom: 10px;
`
